import React from "react";

export type SearchContextType = any;
export const SearchContext = React.createContext<SearchContextType>({});
export const useSearchContext = () => React.useContext(SearchContext);
